import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { customStyle } from '../Components/Style';
import "../Assets/Css/Designation.scss";
import { toast } from 'react-toastify';

function AddDesignationModal({ isModalVisible, closeModal, addDesignation, loading, designationData, updateDesignation,departments = [], designations = []}) {

    const [parent_designation, setParentDesignation] = useState('');
    const [name, setName] = useState('');
    const [selectedDepartments, setSelectedDepartments] = useState(null);

  const departmentOptions = departments?.map(dept => ({ 
        value: dept.name,
        label: dept.name 
    })) || [];

    const designationOptions = designations.map(designation => ({
        value: designation.name,
        label: designation.name
    }));

    useEffect(() => {
        if (isModalVisible) {
            if (designationData) {
                setName(designationData?.name || '');
              const parentDesig = designationOptions.find(desig => 
                    desig.value === designationData?.parent_designation
                );
                setParentDesignation(parentDesig || null);
                 const designationDepts = designationData?.departments?.map(dept => ({ 
                value: dept.name, 
                label: dept.name 
            })) || [];
            setSelectedDepartments(designationDepts);
            }
            else {
                setName('');
                setParentDesignation('');
                setSelectedDepartments([]);
            }
        }
    }, [isModalVisible, designationData,departments,designations]);



    const handleSave = async () => {
        if(!name) {
            toast.error("Please fill all the required fields!")
            return;
        }
        try {
            let body = {
                name,
              parent_designation: parent_designation?.label || parent_designation?.value || null,
                departments: selectedDepartments?.map(d => d.value) || []
            }
            if (designationData) {
                await updateDesignation(designationData?.id, body);
            }
            else {
                await addDesignation(body);
            }
            setName('')
            setParentDesignation('')
            setSelectedDepartments([])
            closeModal()
        } catch (error) {
            console.error("Error adding designation:", error);
        }
    }

    const handleModalClose = () => {
        setName('');
        setParentDesignation('');
        setSelectedDepartments([]);
        closeModal();
    };

    return (
        <Modal show={isModalVisible} onHide={handleModalClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered className="custom-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className='heading'>{designationData ? "Edit" : "Add"} Designation</h5>
                    <button className="btn-close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <div className='add-designation-container'>
                        <div className='add-information-part'>
                            <div className='form-part'>
                                <form>
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className="col-lg-6">
                                                <div className="input-group">
                                                    <h6 className='label'>Designation Name <span className='required-field'> *</span></h6>
                                                    <input type="text" className="input-css" name='designationname' value={name} onChange={(e) => setName(e.target.value)} placeholder='eg. Team Lead' />
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="input-group">
                                                    <h6 className='label'>Parent Designation</h6>
                                                    <Select
                                                        options={designationOptions}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                            }),
                                                        }}
                                                        value={parent_designation}
                                                        placeholder="Select Parent Designation"
                                                        onChange={(val) => setParentDesignation(val || null)}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                        isClearable
                                                    />
                                                </div>
                                             </div>
                                             <div className="col-lg-6">
                                                <div className="input-group">
                                                    <h6 className='label'>Departments</h6>
                                                    <Select
                                                        options={departmentOptions}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                            }),
                                                        }}
                                                        value={selectedDepartments}
                                                        placeholder="Select Departments"
                                                        isMulti
                                                        onChange={(selectedOptions) => {
                                                            setSelectedDepartments(selectedOptions || []);
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer d-flex justify-content-start">
                    <button className="btn-save" onClick={handleSave}>
                        {loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Save"}
                    </button>
                    <button className="btn-cancel" onClick={closeModal}>
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default AddDesignationModal;
